export default __webpack_public_path__ + "static/media/57.ee117e22.jpg";